export const RandomizeField = () => {
  return <div>Randomize Patient</div>;
};

export const ExcludeField = () => {
  return <div>Exclude Patient</div>;
};

export const FileUploadField = () => {
  return <div>Attach necessary documents</div>;
};
